/* eslint-disable no-extend-native*/
import 'intersection-observer';
/**
 * String.prototype.replaceAll() polyfill
 */
if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function (str, newStr) {

        // If a regex pattern
        if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
            return this.replace(str, newStr);
        }

        // If a string
        return this.replace(new RegExp(str, 'g'), newStr);

    };
}

if (typeof Promise.any !== 'function') {
    const any = function (promisesArray) {
        const promiseErrors = new Array((promisesArray instanceof Array ? promisesArray : [promisesArray]).length);
        let counter = 0;

        return new Promise((resolve, reject) => {
            promisesArray.forEach((promise, index) => {
                Promise.resolve(promise)
                    .then(resolve)
                    .catch((error) => {
                        promiseErrors[index] = error;
                        counter = counter + 1;
                        if (counter === promisesArray.length) {
                            reject(promiseErrors);
                        }
                    });
            });
        });
    };
    Promise.any = any;
}
